module.exports = __webpack_public_path__ + "static/media/S2b2cbg2.40bd5066.png";